module.exports = [{"url":"nelly-toncheva","name":"Nelly Toncheva","position":"Direttore commerciale","email":"nelly.toncheva@alcomet.eu","phone":"+35954858625","foreignLanguages":"Inglese","img":"/static/img/contacts/sales_department/nely-toncheva.jpg"}]


//////////////////
// WEBPACK FOOTER
// ./src/components/contacts/MainSalesDepartment.json
// module id = 98Or
// module chunks = 1